import { render, staticRenderFns } from "./CustomVSelect.vue?vue&type=template&id=2a661e2e&scoped=true&"
import script from "./CustomVSelect.vue?vue&type=script&lang=js&"
export * from "./CustomVSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomVSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomVSelect.vue?vue&type=style&index=1&id=2a661e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a661e2e",
  null
  
)

export default component.exports